import { create } from 'zustand';

type WarrantyLogsModalState = {
  isShowCreateModal?: boolean;
  showCreateModal: () => void;
  closeCreateModal: () => void;
};

export const useWarrantyLogsModalStore = create<WarrantyLogsModalState>((set) => ({
  isShowCreateModal: false,
  showCreateModal: () => set({ isShowCreateModal: true }),
  closeCreateModal: () => set({ isShowCreateModal: false })
}));
